import React from 'react';
import classNames from 'classnames';
import styles from 'src/components/icons/Icons.module.scss';

const IconSuccess = ({className, ...props}) => (
    <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg"
         className={classNames(className, styles.svg)} {...props}>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M27.1402 1.0599C26.7671 0.68674 26.1931 0.68674 25.8199 1.0599L7.92008 18.9598L2.18021 13.2199C1.80705 12.8467 1.2331 12.8467 0.859946 13.2199C0.486789 13.5931 0.486789 14.167 0.859946 14.5402L7.25995 20.9402C7.44241 21.1226 7.67801 21.22 7.92008 21.22C8.16215 21.22 8.39774 21.1226 8.58021 20.9402L27.1402 2.38016C27.5134 2.007 27.5134 1.43305 27.1402 1.0599ZM1.07208 13.432C1.16308 13.341 1.27027 13.2824 1.38213 13.2561C1.27029 13.2824 1.16312 13.341 1.07213 13.432C0.816127 13.688 0.816127 14.072 1.07213 14.328L7.47213 20.728C7.58898 20.8449 7.73251 20.9084 7.87835 20.9186C7.73249 20.9084 7.58895 20.8449 7.47208 20.728L1.07208 14.328C0.816078 14.072 0.816078 13.688 1.07208 13.432Z"
              fill="currentColor"/>
    </svg>
);
export default IconSuccess;
